import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home';
import { CompaniesListComponentModule } from '../../components/companies-list/companies-list.module';
import { ComponentsModule } from '../../components/components.module';
import { SharedModule } from './../../app/shared/shared.module';

@NgModule({
  declarations: [
    HomePage,
  ],
  imports: [
    SharedModule,
    IonicPageModule.forChild(HomePage),
    CompaniesListComponentModule,
    ComponentsModule,
  ],
  exports: [
    HomePage
  ]
})
export class HomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts